module.exports = __webpack_public_path__ + "img/hashtag-up.51f43f88.svg";